<img
  [mat-dialog-close]
  [src]="data"
  [typedDialog]="dialogRef"
  style="max-width: 100%; max-height: 100%"
/>
